module.exports = __webpack_public_path__ + "static/media/history.b954d89a.svg";